import { faLocationDotSlash } from "@fortawesome/pro-solid-svg-icons"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import FiberManualRecordIcon from "@mui/icons-material/FiberManualRecord"
import { Tooltip, Typography, useTheme } from "@mui/material"
import React from "react"
import { useTranslation } from "react-i18next"

const DeviceStatus = ({ device }) => {
  const theme = useTheme()
  const { t } = useTranslation()
  return (
    <div style={{ display: "flex", alignItems: "center" }}>
      {device.currentPosition === null && (
        <Tooltip title={t("global.no_position_data", "No position data available")} arrow>
          <span style={{ display: "inline-flex" }}>
            <FontAwesomeIcon
              style={{ color: theme.palette.grey[400], marginRight: "4px" }}
              size="xs"
              icon={faLocationDotSlash}
            />
          </span>
        </Tooltip>
      )}
      <FiberManualRecordIcon
        style={{
          color: device.status === 3 ? theme.palette.error[600] : theme.palette.green[900]
        }}
        fontSize="inherit"
      />
      <Typography
        style={{
          fontSize: "11px",
          marginLeft: "4px"
        }}
        variant="bodyMedium">
        {device.status === 3 ? "Offline" : "Online"}
      </Typography>
    </div>
  )
}

export default DeviceStatus
